import PropTypes from 'prop-types';
import React, { Component, Children, cloneElement } from 'react';
import classNames from 'classnames/bind';
import * as styles from './BreadCrumbs.css';
import { dt } from '../../../helpers/Utils/GetTailwindToken';

const cx = classNames.bind(styles);
/**
 * BreadCrumbs component to display any HTML elements or Components within it,a wrapper compoenent for Crumbs.
 * Currently it supports separator config and . Also support
 * theming
 *
 * BreadCrumbs can be used at many places. E.g Departments,Product Details, Search/Browse
 */

class BreadCrumbs extends Component {
    /**
     * Supported React properties
     * @type {Object}
     */
    static propTypes = {
        /**
         * Separator between crumbs
         * defaults to none.
         * @type {enum}
         */
        separator: PropTypes.oneOf(['slash', 'arrow', 'none', 'custom']),

        /**
         * themeConfig will help in applying a different theme
         * i.e, User can override the default theme by passing
         * themeConfig as props
         * @type {boolean}
         */
        themeConfig: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,

        /**
         * Children nodes of crumbs
         * @type {node}
         */
        children: PropTypes.node,

        saveBreadCrumbAnalytics: PropTypes.func,
        theme: PropTypes.string,
    };

    /** @properties {Default set up} [optonal props set] */
    static defaultProps = {
        children: {},
        separator: 'none',
        themeConfig: [],
        saveBreadCrumbAnalytics: () => {},
        theme: '',
    };

    /**
     * Gets the theme to use
     * @return {[Object]} [theming classes]
     */

    static getThemeConfig(themeConfig, theme) {
        const CrumbContainerStyles = dt([
            'sm:pt-0',
            'sm:px-1',
            'lg:pt-0',
            'lg:px-0',
            'whitespace-nowrap',
            'overflow-x-auto',
            'leading-5',
            'text-small',
            'font-open-sans-regular',
            'flex',
            theme === 'center' && 'justify-center',
        ]);
        const crumbListItemStyle = dt(['inline-block', 'font-open-sans-regular', 'font-small']);
        return {
            crumbContainerClass: `${CrumbContainerStyles} ${cx('crumbContainer')}`,
            crumbListItemClass: `${crumbListItemStyle} ${cx('crumbListItem')}`,
            crumbLinksClass: dt(['text-black']),
            crumbActiveClass: dt(['text-gray-60']),
            crumbsRowClass: dt(['mt-2']),
            ...themeConfig,
        };
    }

    constructor(props) {
        super(props);
        /* istanbul ignore next */
        /**
         * Generating Uniqueid for identifiying each accordion for Accessibility
         * Utils function will be used here
         */
        this.themeConfig = BreadCrumbs.getThemeConfig(props.themeConfig, props.theme);
        this.analyticsCallback = this.analyticsCallback.bind(this);
    }

    getCrumbsConfig(accordionSection, index) {
        return cloneElement(accordionSection, {
            themeConfig: this.themeConfig,
            separator: this.props.separator,
            analyticsCallback: this.analyticsCallback,
            dataIndex: index,
        });
    }

    analyticsCallback(index) {
        const { children, saveBreadCrumbAnalytics } = this.props;
        const totalnumber = children.length;
        const breadCrumbTitles = children.map((crumb) => crumb.props.children).join('->');
        const saveCrumb = totalnumber - Number(index);
        const positionFromLeft = Number(index) + 1;
        saveBreadCrumbAnalytics(totalnumber, saveCrumb, positionFromLeft, breadCrumbTitles);
    }

    /**
     * Renders all the children inside it
     * @return {[type]} [description]
     */
    render() {
        // Breadcrumbs configuration and theming
        const crumbs = Children.map(this.props.children, this.getCrumbsConfig, this);
        return (
            <div className={this.themeConfig.crumbsRowClass} data-automation-id="breadcrumbRow">
                <ul className={this.themeConfig.crumbContainerClass}>{crumbs}</ul>
            </div>
        );
    }
}

export default BreadCrumbs;
